import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { HttpRequestService } from '../../services/HttpRequestService';
import moment from 'moment'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { UtilsService } from '../../services/UtilsService';
import Checkbox from '../../common/Checkbox';
import Report from '../../common/Report';
import RadioGroup from '../../common/RadioGroup';
import StateMultipleSelect from '../../common/StateMultipleSelect';
import ProductTree from '../../common/ProductTree';

class CsoProductSalesReport extends Component {

    constructor(props) {
        super(props);
        this.utils = new UtilsService();
        var initialState = {
            accountTypes: [],
            accountTypeIds: "",
            productIds: "",
            beginDate: moment(new Date()).toDate(),
            endDate: moment(new Date()).toDate(),
            dateType: "FulfillDate",
            companyId: -1,
            accountTypeId: -1,
            stateIds: [9, 10, 13, 30, 44, 47],
            groupByState: true,
            includePending: false,
            report: null,
            showInactive: false,
        }
        this.sortBy = "";
        this.sortDirection = "";
        this.paramsKey = "params.cso-product-sales-report";
        this.state = this.utils.prepareSessionState(initialState, this.paramsKey);

        this.http = new HttpRequestService();
        this.handleBeginDateChange = this.handleBeginDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handleDateTypeChange = this.handleDateTypeChange.bind(this);
        this.handleAccountTypeChange = this.handleAccountTypeChange.bind(this);
        this.handleIncludePendingChange = this.handleIncludePendingChange.bind(this);
        this.handleStatesChange = this.handleStatesChange.bind(this);
        this.handleGroupByStateChange = this.handleGroupByStateChange.bind(this);
        this.handleProductIdsChange = this.handleProductIdsChange.bind(this);
        this.hasAccountType = this.hasAccountType.bind(this);
        this.getAccountTypes = this.getAccountTypes.bind(this);
        this.getReport = this.getReport.bind(this);
        this.sortReport = this.sortReport.bind(this);
    }

    componentDidMount() {
        this.getAccountTypes();
    }

    handleBeginDateChange(e) {
        this.setState({ beginDate: e });
    }

    handleEndDateChange(e) {
        this.setState({ endDate: e });
    }

    handleIncludePendingChange(checked) {
        this.setState({ includePending: checked });
    }

    handleDateTypeChange(value) {
        this.setState({
            dateType: value
        });
    }

    handleStatesChange(states) {
        this.setState({ stateIds: states });
    }

    handleGroupByStateChange(checked) {
        this.setState({ groupByState: checked });
    }

    handleShowInactiveChange(checked) {
        this.setState({ showInactive: checked }, this.getProductTree);
    }

    handleAccountTypeChange(checked, accountType) {
        var accountTypeIds = this.state.accountTypeIds;
        var arr = accountTypeIds !== "" ? accountTypeIds.split(",") : [];
        if (checked) {
            arr.push(accountType.key);
            this.setState({
                accountTypeIds: arr.length > 0 ? arr.join(",") : ""
            });
        }
        else {
            arr.splice(arr.findIndex(a => a === accountType.key), 1);
            this.setState({
                accountTypeIds: arr.length > 0 ? arr.join(",") : ""
            });
        }
    }

    hasAccountType(accountType) {
        var selectedAccountTypeIds = this.state.accountTypeIds.split(",");
        var result = selectedAccountTypeIds.find(a => a === accountType.key);
        return !!result;
    }

    handleProductIdsChange(val) {
        this.setState({ productIds: val });
    }

    filterStates(states) {
        // var allowedStates = ["Florida", "Texas", "Georgia", "Illinois", "New Jersey", "Virginia"];
        // return states.filter(s => allowedStates.indexOf(s.name) >= 0);
        // Allow all states
        return states;
    }

    getPrintPDFUrl(type, order) {
        return this.http.HOST + "/Print/Order?type=" + type + "&OrderID=" + order.orderID + "&OrderNumber=" + order.orderNumber;
    }

    getAccountTypes() {
        this.http.get('/api/Orders/GetAccountTypes', null).then(data => {
            data = [...data, { key: "Target", value: "Target" }]
            var allowedAccountTypes = ["Web/Retail", "Amazon", "Walmart", "Target"];
            data = data.filter(d => allowedAccountTypes.indexOf(d.value) >= 0);
            if (this.state.accountTypeIds.length === 0) {
                var accountTypeIds = data.map(function (a) {
                    return a.key;
                });
                this.setState({
                    accountTypeIds: accountTypeIds.join(",")
                })
            }
            this.setState({ accountTypes: data });
        });
    }

    getReport(e) {
        if (!!e) {
            e.preventDefault();
        }
        var productIds = [];
        var data = window.$("#productsTree").jstree().get_selected();
        for (var i = 0; i < data.length; i++) {
            var parsed = parseInt(data[i]);
            if (!isNaN(parsed)) {
                productIds.push(data[i]);
            }
        }

        this.setState({
            productIds: productIds
        }, () => {

            var params = {
                beginDate: this.state.beginDate != null ? moment(this.state.beginDate).format('L') : "",
                endDate: this.state.endDate != null ? moment(this.state.endDate).format('L') : "",
                dateType: this.state.dateType,
                accountTypeIds: this.state.accountTypeIds,
                productIds: this.state.productIds.join(","),
                stateIds: this.state.stateIds.join(","),
                groupByState: this.state.groupByState,
                includePending: this.state.includePending,
                sortBy: this.sortBy,
                sortDirection: this.sortDirection
            }
            sessionStorage.setItem(this.paramsKey, JSON.stringify(params));
            this.http.get('/api/Report/GetCsoProductSalesReport', params).then(data => {
                this.setState({ report: data });
            });
        });
    }

    sortReport(field) {
        if (this.sortBy !== field) {
            this.sortDirection = "ASC";
        }
        else {
            if (this.sortDirection === "ASC") {
                this.sortDirection = "DESC";
            }
            else {
                this.sortDirection = "ASC";
            }
        }
        this.sortBy = field;
        this.getReport();
    }

    render() {
        return (
            <div className="page-inner">
                <div className="page-header">
                    <h4 className="page-title">CSO Product Sales Report</h4>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-body">
                                <form onSubmit={e => this.getReport(e)}>
                                    <div className="form-row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Date Type</label>
                                                <RadioGroup groupName="dateType" value={this.state.dateType} items={[{ value: "FulfillDate", text: "Fulfilled Date" }, { value: "EnteredDate", text: "Entered Date" }]} onChange={this.handleDateTypeChange}></RadioGroup>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="beginDate">Invoices From</label>
                                                <DatePicker className="form-control" selected={this.state.beginDate} onChange={this.handleBeginDateChange} />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="endDate">Invoices To</label>
                                                <DatePicker className="form-control" selected={this.state.endDate} onChange={this.handleEndDateChange} />
                                            </div>
                                            <div className="form-group">
                                                <Checkbox label="Include Pending Orders (Pending/Open/On Hold)" checked={this.state.includePending} onChange={this.handleIncludePendingChange}></Checkbox>
                                            </div>
                                            <div className="form-group">
                                                <label>State</label>
                                                <StateMultipleSelect filter={this.filterStates} countryID={211} value={this.state.stateIds} onChange={this.handleStatesChange}></StateMultipleSelect>
                                            </div>
                                            <div className="form-group">
                                                <label>AccountTypes</label>
                                                <div>
                                                    {this.state.accountTypes.map(accountType =>
                                                        <Checkbox style={{ display: "inline-block" }} key={accountType.key} label={accountType.value} checked={this.hasAccountType(accountType)} onChange={(checked) => this.handleAccountTypeChange(checked, accountType)}></Checkbox>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <Checkbox label="Group by State" checked={this.state.groupByState} onChange={this.handleGroupByStateChange}></Checkbox>
                                            </div>

                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Products</label>
                                                <ProductTree cso={true} value={this.state.productIds} onChange={this.handleProductIdsChange}></ProductTree>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-row justify-content-end">
                                        <button type="submit" className="btn btn-primary">Submit</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        {this.state.report != null &&
                            <Report name="ProductSalesReport" hasData={this.state.report.items && this.state.report.items.length > 0} title="Product Sales Report" description={this.state.report.description}>
                                <div className="form-row">
                                    <table className="table table-striped mt-1 report-table">
                                        <React.Fragment>
                                            {this.state.report.items.map((monthGroup) =>
                                                <React.Fragment key={monthGroup.name}>
                                                    <thead>
                                                        <tr className="bg-info reportHeader">
                                                            <th colSpan={8}>{monthGroup.name}</th>
                                                        </tr>
                                                    </thead>
                                                    {!this.state.groupByState &&
                                                        <tbody>
                                                            <tr>
                                                                <th scope="col">PRODUCT NAME</th>
                                                                <th className="currency" scope="col">QUANTITY</th>
                                                                <th className="currency" scope="col">PRICE</th>
                                                            </tr>
                                                            {monthGroup.items && monthGroup.items.map(productGroup =>
                                                                <React.Fragment>
                                                                    {productGroup.total.map((g, i) =>
                                                                        <tr key={i}>
                                                                            <td>{productGroup.name}</td>
                                                                            <td className="currency">{productGroup.currencyQuantities[g.currency.toLowerCase()]}</td>
                                                                            <th className="currency">{this.utils.toCurrency(g.amount, g.currency)}</th>
                                                                        </tr>
                                                                    )}
                                                                </React.Fragment>
                                                            )}
                                                            {monthGroup.total.map((t, i) =>
                                                                <tr key={i} className="reportFooter">
                                                                    <th></th>
                                                                    <th className="currency">{monthGroup.currencyQuantities[t.currency.toLowerCase()]}</th>
                                                                    <th className="currency">{this.utils.toCurrency(t.amount, t.currency)}</th>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    }
                                                    {this.state.groupByState &&
                                                        <tbody>
                                                            {monthGroup.stateItems && monthGroup.stateItems.map((stateGroup) =>
                                                                <React.Fragment>
                                                                    <tr key={stateGroup.name} className="bg-primary2 reportHeader">
                                                                        <th colSpan={8}>{stateGroup.name}</th>
                                                                    </tr>
                                                                    {stateGroup.items.map((salesmanGroup) =>
                                                                        <React.Fragment>
                                                                            <tr key={salesmanGroup.name} className="bg-secondary reportHeader">
                                                                                <th colSpan={8}>{salesmanGroup.name}</th>
                                                                            </tr>
                                                                            <tr>
                                                                                <th scope="col">PRODUCT NAME</th>
                                                                                <th className="currency" scope="col">QUANTITY</th>
                                                                                <th className="currency" scope="col">PRICE</th>
                                                                            </tr>
                                                                            {salesmanGroup.items && salesmanGroup.items.map((productGroup, index) =>
                                                                                <tr key={index}>
                                                                                    <td>{productGroup.productName}</td>
                                                                                    <td className="currency">{productGroup.quantityShipped}</td>
                                                                                    <td className="currency">{this.utils.toCurrency(productGroup.calculatedTotal, productGroup.currencyCode)}</td>
                                                                                </tr>
                                                                            )}
                                                                            {salesmanGroup.total.map((t, i) =>
                                                                                <tr key={i} className="bg-light reportFooter">
                                                                                    <th></th>
                                                                                    <th className="currency">{salesmanGroup.currencyQuantities[t.currency.toLowerCase()]}</th>
                                                                                    <th className="currency">{this.utils.toCurrency(t.amount, t.currency)}</th>
                                                                                </tr>
                                                                            )}
                                                                        </React.Fragment>
                                                                    )}
                                                                    {stateGroup.total.map((t, i) =>
                                                                        <tr key={i} className="bg-light reportFooter">
                                                                            <th></th>
                                                                            <th className="currency">{stateGroup.currencyQuantities[t.currency.toLowerCase()]}</th>
                                                                            <th className="currency">{this.utils.toCurrency(t.amount, t.currency)}</th>
                                                                        </tr>
                                                                    )}
                                                                </React.Fragment>
                                                            )}
                                                            {monthGroup.total.map((t, i) =>
                                                                <tr key={i} className="bg-dark reportFooter">
                                                                    <th></th>
                                                                    <th className="currency">{monthGroup.currencyQuantities[t.currency.toLowerCase()]}</th>
                                                                    <th className="currency">{this.utils.toCurrency(t.amount, t.currency)}</th>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    }
                                                </React.Fragment>
                                            )}
                                            <tbody>
                                                {this.state.report.total.map((t, i) =>
                                                    <tr key={i} className="bg-dark reportFooter">
                                                        <th></th>
                                                        <th className="currency">{this.state.report.currencyQuantities[t.currency.toLowerCase()]}</th>
                                                        <th className="currency">{this.utils.toCurrency(t.amount, t.currency)}</th>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </React.Fragment>
                                    </table>
                                </div>
                            </Report>
                        }
                    </div>
                </div>
            </div >
        );
    }
}

export default CsoProductSalesReport;
